// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4541":"27c3e019","5121":"e06937fb"}[chunkId] + ".chunk.css";
};